document.querySelectorAll('.product__color-chips button').forEach(button => {
    button.addEventListener('click', function() {
        setTimeout(() => {
            const variantId = document.querySelector('[name="id"]')?.value;
            if (variantId) {
                console.log('Selected Variant ID:', variantId);
              if (typeof FabrikatorPreOrder === 'undefined') {
                return;
              }
            
              if (!window.FabrikatorPreOrderInstance) {
                return
              }
            
              const formControl = window.FabrikatorPreOrderInstance.findFormControl(window.FabrikatorPreOrderInstance.addToCartButton);
              if (!formControl) {
                return;
              }
            
              window.FabrikatorPreOrderInstance.variantMetafieldExists(formControl, variantId);
            }
        }, 50);
    });
});
//custom script for hiding zero item carts
const cartCount = document.querySelector('[data-js-cart-count]');
if (cartCount) {
  const updateVisibility = () => {
    cartCount.style.display = cartCount.textContent.trim() === '0' ? 'none' : '';
  };

  updateVisibility(); // run initially

  const observer = new MutationObserver(updateVisibility);
  observer.observe(cartCount, { childList: true, characterData: true, subtree: true });
}